var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{staticClass:"h-100",attrs:{"show":_vm.loading,"rounded":"sm"}},[_c('Card',{staticClass:"m-0 shadow-none",attrs:{"header":_vm.$t('sales')}},[(_vm.error)?_c('ErrorMessage',{attrs:{"value":_vm.error}}):_c('Chart',{attrs:{"height":400,"series":_vm.chartSeries,"options":_vm.chartOptions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }